export function useCache() {
  const cache: Record<string, any> = new Map();

  return {
    getCache: function (key: string, obj: any) {
      return cache[key] || (cache[key] = obj);
    },
    getCacheWithFn: function (key: string, fn: () => any) {
      return cache[key] || (cache[key] = fn());
    }
  };
}
